import instance from "../utils/api_instance.util";

export const fetchCategoryListAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/fetchCategoryList', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const createCategoryAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/create', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const fetchCategoryByIdAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/fetchCategoryDetails', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateCategoryAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/updateCategory', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const changeCategoryStatusAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/changeCategoryStatus', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const getAllCategoryListAPI = async () => {
    try {
        const { data } = await instance.get('/api/v1/admin/category/getAllCategories');
        return data;
    } catch (err) {
        throw err;
    }
}

/* Sub category API's */

export const fetchSubCategoryListAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/fetchSubCategoryList', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const createSubCategoryAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/createSubCategories', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const fetchSubCategoryByIdAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/fetchSubCategoryById', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const updateSubCategoryAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/updateSubCategory', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const changeSubCategoryStatusAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/updateSubCategoryStatus', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const getAllSubCatagoriesAPI = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/fetchSubCategoriesByCategoryId', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}


// new

export const createSubCategoryAPIV2 = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/createSubCategoryv2', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const fetchSubCategoryListAPIV2 = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/fetchSubCategoryListv2', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}
export const fetchSubCategoryByIdAPIV2 = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/fetchSubCategoryByIdv2', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}
export const updateSubCategoryAPIV2 = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/updateSubCategoryv2', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}

export const getAllSubCatagoriesAPIV2 = async (payload) => {
    try {
        const { data } = await instance.post('/api/v1/admin/category/fetchSubCategoriesByCategoryIdv2', { ...payload });
        return data;
    } catch (err) {
        throw err;
    }
}